var _rect, _path, _path2, _rect2, _path3, _circle, _circle2, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "#D7F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.5V21",
    stroke: "#007E8C",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15.5V21",
    stroke: "#007E8C",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19,
    width: 26,
    height: 22,
    rx: 6,
    fill: "#007E8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26H40",
    stroke: "#D7F9FD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 31.5,
    r: 1.5,
    fill: "#D7F9FD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 31.5,
    r: 1.5,
    fill: "#D7F9FD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 31.5,
    r: 1.5,
    fill: "#83D2DA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 36.5,
    r: 1.5,
    fill: "#83D2DA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36.5,
    r: 1.5,
    fill: "#D7F9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.3ce62f01c4c1cb4801a108cd716de020.svg";
export { ForwardRef as ReactComponent };